import styled from "styled-components/macro"
import { Collapsible } from "@humanpredictiveintelligence/myqvt-library"

export const Choices = styled(Collapsible)``

export const Choice = styled.div`
  margin: 8px 0;
`

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: left;
`

export const Error = styled.div`
  margin: 8px 0;
  color: ${({ theme }) => theme.colors.danger};
`
